import { Controller } from "@hotwired/stimulus"
import { renderReport } from "../render.js"

export default class extends Controller {
  static targets = ["mount"]
  static values = {
    report: Object,
    locale: { type: String, default: "ru" },
    portraitBase: { type: String, default: "/static/portraits" },
    portraitUrls: { type: Object, default: {} },
    imageUrls: { type: Object, default: {} },
  }

  connect() {
    this.render()
  }

  reportValueChanged() {
    this.render()
  }

  localeValueChanged() {
    this.render()
  }

  portraitBaseValueChanged() {
    this.render()
  }

  portraitUrlsValueChanged() {
    this.render()
  }

  imageUrlsValueChanged() {
    this.render()
  }

  audience() {
    return this.element.closest("[data-report-audience]")?.getAttribute("data-report-audience") || ""
  }

  render() {
    if (!this.hasMountTarget) return
    const report = this.reportValue || {}
    renderReport(report, this.mountTarget, {
      locale: this.localeValue || "ru",
      portraitBase: this.portraitBaseValue || "/static/portraits",
      portraitUrls: this.portraitUrlsValue || {},
      imageUrls: this.imageUrlsValue || {},
      audience: this.audience(),
      instrumentCode: report.instrument_code || "",
    })
  }
}
